import { render, staticRenderFns } from "./impressum.vue?vue&type=template&id=89043042&"
import script from "./impressum.vue?vue&type=script&lang=ts&"
export * from "./impressum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89043042')) {
      api.createRecord('89043042', component.options)
    } else {
      api.reload('89043042', component.options)
    }
    module.hot.accept("./impressum.vue?vue&type=template&id=89043042&", function () {
      api.rerender('89043042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/views/impressum.vue"
export default component.exports